<template>
  <transition name="slide-fade">
    <div
      class="holderInputs"
      :style="{ zoom: `1.${getWebchat().client.accessibility.fontSize}` }"
    >
      <v-card
        class="header-card"
        :style="{
          'background-color': getWebchat().campaign.color,
          color: invertColor(getWebchat().campaign.color),
        }"
      >
        <v-btn
          icon
          v-if="getWebchat().isLowRes"
          @click.native="minimizeWindow"
          class="left-arrow-back"
        >
          <v-icon
            x-large
            :style="{
              color: invertColor(getWebchat().campaign.color),
            }"
            style="font-size: 28px !important"
            >mdi-close</v-icon
          >
        </v-btn>
        <div class="header-content">
          <div
            class="vtext-content"
            :style="{
              color: invertColor(getWebchat().campaign.color),
            }"
            v-html="getTitleMessage"
          ></div>
        </div>
      </v-card>
      <v-card class="survey-content">
        <star-rating
          v-model="rating"
          :show-rating="false"
          :increment="getWebchat().campaign.fullStars == 0 ? 0.5 : 1"
          class="star-rating-comp"
        ></star-rating>
        <v-switch
          v-if="getWebchat().campaign.show_email"
          v-model="sendmail"
          :color="getWebchat().campaign.color"
          :label="$t('sendbymail')"
          class="switch-align"
        ></v-switch>
        <div class="containerTextArea" style="padding: 9px 20px">
          <v-text-field
            v-model="surveyMessage"
            :label="$t('message')"
            maxlength="300"
            counter="300"
          ></v-text-field>
        </div>
        <v-btn
          id="btnEnviar"
          width="100%"
          rounded
          @click="clickSend"
          :style="{
            'background-color': getWebchat().campaign.color,
            color: invertColor(getWebchat().campaign.color),
          }"
          style="font-size: 2.8vw"
        >
          {{ $t("sendpunctuation") }} &nbsp;
          <Send :color="invertColor(getWebchat().campaign.color)" size="20px" />
        </v-btn>
      </v-card>
    </div>
  </transition>
</template>

<script>
import { invertColor } from "@/assets/utils";
import StarRating from "vue-star-rating";
import Send from "./../assets/send.vue";
export default {
  name: "survey",
  components: {
    StarRating,
    Send,
  },

  data() {
    return {
      window: window,
      Send,
    };
  },

  computed: {
    rating: {
      get() {
        const campaignName = this.$route.query.campaign;

        const index = this.$store.state.findIndex(
          (e) => e.configuration.campaign === campaignName
        );

        return this.$store.state[index].client.rating;
      },

      set(value) {
        this.$store.commit("setRatingValue", value);
      },
    },

    surveyMessage: {
      get() {
        const campaignName = this.$route.query.campaign;

        const index = this.$store.state.findIndex(
          (e) => e.configuration.campaign === campaignName
        );

        return this.$store.state[index].client.surveyMessage;
      },

      set(value) {
        this.$store.commit("setSurveyMessage", value);
      },
    },

    sendmail: {
      get() {
        const campaignName = this.$route.query.campaign;

        const index = this.$store.state.findIndex(
          (e) => e.configuration.campaign === campaignName
        );

        return this.$store.state[index].client.sendmail;
      },

      set(value) {
        this.$store.commit("setSendMail", value);
      },
    },

    getTitleMessage() {
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      let title = this.$store.state[index].campaign.feedback;
      let lang = this.$store.state[index].client.lang;
      return title[lang];
    },
  },

  mounted() {
    this.$store.commit("clearSurveyMessage");
    this.$store.commit("clearCalification");
  },

  methods: {
    invertColor,
    /**
     * @name CLICK_SEND
     * @desc Checks if rating was chosen and sends info back to server
     */
    async clickSend() {
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      if (this.rating) {
        try {
          await this.$http.get(
            "https://" +
              this.$store.state[index].configuration.ip +
              "/IntegraChannels/resources/webchat/rating",
            {
              params: {
                guid: this.$store.state[index].interaction.guid,
                rating:
                  this.$store.state[index].client.rating *
                  (this.$store.state[index].campaign.fullStars == 0 ? 2 : 1),
                comments: this.$store.state[index].client.surveyMessage,
                mail: this.$store.state[index].client.sendmail ? 1 : 0,
                from: this.$store.state[index].client.mail,
              },
            }
          );

          // Re-routing to main app page
          this.$store.commit("noStartedInteraction");
          this.$router.push({
            path: "/form",
            query: {
              campaign: campaignName,
            },
          });
          window.parent.postMessage({ action: "SURVEYCOMPLETED" }, "*");
        } catch (error) {
          console.warn("ERROR SENDING REQUEST => ", error);
        }
      } else {
        this.$toast.bottom(this.$t("youmustpickastar"));
      }
    },

    /**
     * @name MINIMIZE_WINDOW
     * @desc Broadcast event to entrypoint to minimize the chat
     */
    minimizeWindow() {
      window.parent.postMessage({ action: "MINIMIZE" }, "*");
    },

    getWebchat() {
      return this.$store.state[
        this.$store.state.findIndex(
          (e) => e.configuration.campaign === this.$route.query.campaign
        )
      ];
    },
  },
};
</script>

<style>
.rating-text {
  display: none !important;
}

.star-rating {
  margin: auto !important;
  margin-top: 13px !important;
}

svg.vue-star-rating-star {
  width: 100%;
}

span.vue-star-rating-pointer.vue-star-rating-star {
  width: 20%;
}

.switch-align {
  margin-left: 7px;
  margin-top: 10px;
}

.switch-align label {
  max-width: none !important;
}
</style>

<style scoped>
.md-input-container textarea {
  max-height: 130px;
  overflow-y: scroll;
}

#btnEnviar {
  outline: none;

  top: 39px;
  position: relative;
  margin: auto;
  display: block;
  font-size: 1em;

  font-weight: 400;
  color: white;
  height: 45px;
  cursor: pointer;
  margin-bottom: 1em;
}

.padding-mdswitch {
  padding: 16px;
  margin-bottom: 0px;
}

.star-rating-comp {
  justify-content: center;
  margin-bottom: 47px;
}

.holderInputs {
  height: 100%;
  width: 100%;
  position: absolute;
  background-color: #fff;
  padding: 0 0;
}

.holderInputs-externalWindow {
  padding: 5%;
}

.holder-inputs-mobile {
  margin-bottom: 0;
  margin-top: 0;
}

#holderOnTime {
  font-size: 18px;
  margin-bottom: 45px;
  color: #00000069;
}

.header-card {
  border-radius: 6px 6px 0 0 !important;
  width: 100%;
  z-index: 0;
}

.v-card__media__content {
  margin-right: -50px !important; /* maximum width of scrollbar */
  padding-right: 50px !important; /* maximum width of scrollbar */
  overflow-y: scroll !important;
}

.left-arrow-back {
  position: absolute !important;
  top: 2px;
  right: 3px;
  z-index: 99;
  transition: all 0.3s ease;
}

.left-arrow-back i {
  font-size: 39px !important;
}

.welcome-message-header {
  transition: all 0.3s ease-out;
  opacity: 0;
  padding-bottom: 97px;
}

.welcome-message-header.show {
  transition: all 0.3s ease-out;
  opacity: 100;
}

.header-card::after {
  content: "";
  background: linear-gradient(
    135deg,
    rgba(35, 146, 236, 0),
    rgba(0, 0, 0, 0.52)
  );
  background-blend-mode: overlay;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: -1;
}

.header-content {
  padding: 32px 41px 80px 40px;
}

.vtext-content {
  text-align: left;
  color: #fff;
}

.vtext-content > span,
.vtext-content > strong,
.vtext-content > i {
  position: relative;
  top: 10px;
  font-size: 13px;
  line-height: 28px;
}

.vtext-content img {
  position: relative !important;
  bottom: -3px !important;
}

.vtext-content > h1,
.vtext-content > h2,
.vtext-content > h3,
.vtext-content > h4,
.vtext-content > h5,
.vtext-content > h6 {
  font-weight: 200;
  position: relative;
  left: -2px;
}

.survey-content {
  margin: 28px;
  position: relative;
  padding: 23px;
  top: -87px;
  height: 387px;
}
</style>
